// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__XaNpj","title":"Header_title__a3JC3"};